import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";
import { localStorageConstants } from "../../../consts/local_storage_constants";

export function amountChange(params: any) {
    params = params.target.value;
    if (params == '') {
      return '00.00';
    } else {
      let tempText = '';
      if (params.match(numbers!)) {
        var numbers = /^[0-9]+$/;
        let a = params;
        a = a.replace(/,/g, '');
        const dotIndex = a.indexOf('.');
        const count = a.substring(dotIndex + 1).length;
        let multiply;
        if (count == 1) {
          multiply = 10;
        } else {
          multiply = 1000;
        }
        const temp = (Number(a) * multiply) / 100;
        tempText = temp.toFixed(2);
      }
      const dotSplit = tempText.split('.');
      if (dotSplit[0].length > 3) {
        const code = dotSplit[0];
        const modules = code.length % 3 == 0 ? 0 : code.length + (3 - (code.length % 3));
        const newCode: any = code.padStart(modules, 'X');
        let finalCode = newCode.match(/.{1,3}/g).join(',');
        finalCode = finalCode.toString().replace(/X/g, '');
        tempText = `${finalCode}.${dotSplit[1]}`;
      }
      return tempText;
    }
  }


/**
 * Extracts all data from JWT token
 * @returns {object|null} Decoded token payload or null if invalid
 */
export const getTokenData = () => {
  try {
    const token = localStorage.getItem(localStorageConstants.PORTAL_TOKEN);
    if (!token) return null;

    const payload = token.split('.')[1];
    if (!payload) return null;

    return JSON.parse(
      atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
    );
  } catch (error) {
    console.error('Token decoding failed:', error);
    return null;
  }
};

// password.validator.ts


export class PasswordValidator {
  static matchPassword: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const password = control.get('password');
    const confirmPassword = control.get('confirmPassword');

    if (!password || !confirmPassword) {
      return null;
    }

    return password.value === confirmPassword.value ? null : { passwordMismatch: true };
  };
}